module.exports = __webpack_public_path__ + "img/K-head_black_RGB.d51f53a8.png";